// extracted by mini-css-extract-plugin
export default {"card":"TrainingCard_card__GdlQF","bg_image":"TrainingCard_bg_image__DmpY0","bg_image_background":"TrainingCard_bg_image_background__TSuge"};